"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManagerLayoutContentHeading = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ManagerLayoutContentHeading = function ManagerLayoutContentHeading(_ref) {
  var title = _ref.title,
    ctaText = _ref.ctaText,
    className = _ref.className,
    onCtaClick = _ref.onCtaClick,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex mb-[16px]', className)
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-sm-medium text-grey-75"
  }, title), children, ctaText && /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    icon: "add-heavy-16",
    iconPosition: "left",
    onClick: onCtaClick
  }, ctaText));
};
exports.ManagerLayoutContentHeading = ManagerLayoutContentHeading;